<div
  class="tipo-de-obra-content titles"
  appDropdownToggle
  #dropdown="dropdownToggle"
  (click)="!disabled && dropdown.toggle()"
  [class.disabled]="disabled"
  tabindex="0"
  
>
  <div class="icon-text">
    <span class="icon-circle">
      <img
        class="img-icon"
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/location_on.svg"
        alt=""
        width="22"
        height="22"
      />
    </span>

    <h2>Região de buscas</h2>
  </div>
  <a
    class="btn tipo-de-obra-link"
    data-bs-toggle="collapse"
    role="button"
    aria-expanded="true"
    href="#btn-regiao"
    (click)="$event.stopPropagation(); !disabled && dropdown.toggle()"
    (keydown.enter)="!disabled && dropdown.toggle()"
    (keydown.space)="!disabled && dropdown.toggle()"
  >
    <img
      class="img-icon"
      [ngClass]="{ 'girar-icon': dropdown.isOpen }"
      src="{{
        BASE_IMG_URL
      }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
      alt=""
      width="18"
      height="18"
    />
  </a>
</div>

 <div class="regiao">
        <select
          [(ngModel)]="regiaoSelecionada"
          name="regiao"
          (change)="onSelectChange($event)"
          [disabled]="disabled"
          [class.disabled]="disabled"
        >
          <option *ngIf="exibirTodasRegioes" [value]="0">
            TODAS AS REGIÕES
          </option>
          <option [value]="defaultRegion" disabled *ngIf="!regiaoSelecionada" >
            Selecione a região
          </option>

          <option
            *ngFor="let regiao of filtroRegiao"
            [value]="regiao.regionID"
            [selected]="regiao.regionID === defaultRegion"
            [disabled]="disabled"
          >
            {{ regiao.regionDescription }}
          </option>
        </select>
      </div>


      <div
        *ngIf="regiaoSelecionada !== 0 && states.length > 0"
        class="check-total location"
      >
        <ul>
          <li *ngFor="let states of states; let i = index" class="location-li">
            <div class="location-wrapper">
              <div class="input-label-group">
                <input
                  type="checkbox"
                  class="form-check-input checkbox"
                  [id]="'states_' + i"
                  name="checkbox_{{ states.stateDescription }}"
                  [checked]="
                    selectedStates.includes(states.stateID) ||
                    defaultState === states.stateID
                  "
                  (change)="onStatesCheckboxChange(states, $event)"
                 [disabled]="disabled"
                />

                <label class="form-check-label" [for]="'states_' + i">
                  {{ states.stateDescription }}
                </label>
              </div>

              <a
                *ngIf="states.cities && states.cities.length > 0"
                class="img-container"
                (click)="toggleDropdownIcon(states)"
              >
                <img
                  class="img-icon img-location"
                  src="{{
                    BASE_IMG_URL
                  }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
                  alt="Ícone de seta"
                  width="18"
                  height="18"
                />
              </a>
            </div>

            <div *ngIf="states.isDropdownOpen" class="districts-dropdown">
              <ul>
                <li
                  *ngFor="let city of states.cities; let j = index"
                  class="districts-li"
                >
                  <input
                    type="checkbox"
                    class="form-check-input checkbox"
                    [id]="'cities_' + states.stateID + '_' + j"
                    name="checkbox_{{ city.cityDescription }}"
                    [checked]="city.checked == true"
                    (change)="
                      onCitiesCheckboxChange(city, states.cities, $event)
                    "
                    [disabled]="disabled"
                  />
                  <label
                    class="form-check-label"
                    [for]="'cities_' + states.stateID + '_' + j"
                  >
                    {{ city.cityDescription }}
                  </label>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>